<template>
  <div v-once :id="idOfDomTarget">
  </div>
</template> 

<script>
import Vue from "vue";
import createUuid from "uuid/v4";
import { Gfx3dApi } from "./gfx3d.js";

function createIdOfDomTarget() {
  let uuid = createUuid()
    .split("-")
    .join("_");
  return `ggbApplet_${uuid}`;
}

export default {
  data() {
    return {
      idOfDomTarget: createIdOfDomTarget()
    };
  },
  props: {
    width: { type: Number, default: 400 },
    height: { type: Number, default: 300 }
  },
  methods: {},
  mounted() {
    const that = this;
    Vue.nextTick(async function() {
      let api = new Gfx3dApi(that.idOfDomTarget);
      that.$gfx3dApi = api;
      await api.init({ width: that.width, height: that.height });
      that.$emit("onGfx3dApiReady", api);
    });
  }
};
</script>
 

<style scoped>
</style>